import { Box, Button, Heading, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

const AcceptInvite = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error

  useEffect(() => {
    const accept = async () => {
      if (!token) {
        setStatus("error");
        return;
      }
      const accessToken = localStorage.getItem("token");
      if (!accessToken) {
        // Not logged in — send to login, then come back
        navigate(`/login?redirect=/accept-invite?token=${token}`);
        return;
      }
      try {
        const baseUrl = getHostDomain();
        await fetchController(baseUrl + "/api/v1/team/accept_invite", "POST", { token });
        setStatus("success");
        toast.success("You've joined the team!");
        setTimeout(() => navigate("/"), 2000);
      } catch (err) {
        const msg = err?.response?.data?.detail || "Failed to accept invite";
        toast.error(msg);
        setStatus("error");
      }
    };
    accept();
  }, [token]);

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={4}>
      {status === "loading" && (
        <>
          <Spinner size="xl" />
          <Text>Accepting your invite...</Text>
        </>
      )}
      {status === "success" && (
        <>
          <Heading size="md">You're in!</Heading>
          <Text>Redirecting to dashboard...</Text>
        </>
      )}
      {status === "error" && (
        <>
          <Heading size="md" color="red.500">Invite failed</Heading>
          <Text>The invite may have expired or already been used.</Text>
          <Button onClick={() => navigate("/")}>Go to Dashboard</Button>
        </>
      )}
    </Box>
  );
};

export default AcceptInvite;
